import { useEffect } from 'react'

import AppConfig from '@src/config/AppConfig'

const OmniauthLoginRedirect: React.FC = () => {
  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search)
    let redirectUrl = searchParams.get('redirect_url')
    if (redirectUrl?.startsWith('/')) {
      redirectUrl = `${window.location.protocol}//${window.location.host}${redirectUrl}`
    }

    window.location.replace(
      `${AppConfig.OMNIAUTH_BASE}/login${
        redirectUrl ? `?redirect=${encodeURIComponent(redirectUrl)}` : ''
      }`,
    )
  }, [])

  return null
}

export default OmniauthLoginRedirect
